const supportsFlags = {};
export {
  supportsFlags
};
